import {
    ClickElement,
    ClickText,
    GA4EventName,
    GA4FeatureCategory,
    trackAnalyticsEvent,
} from '@jsmdg/tracking';

async function trackRedeemInfoClicked(): Promise<void> {
    await window.yieldToMainThread();
    trackAnalyticsEvent({
        eventData: {
            eventName: GA4EventName.ClickTextLink,
            feature_category: GA4FeatureCategory.ProductdetailBuybox,
            click_element: ClickElement.FlexiblyRedeemable,
            click_text: ClickText.FlexibleRedemption,
        },
    });
}

export { trackRedeemInfoClicked };
